import { Component, StatelessComponent, ReactNode } from 'react'
import * as styles from 'styles/atoms/Overview.css'

type OverviewSectionProps = {
  title: ReactNode
}

const OverviewSection: StatelessComponent<OverviewSectionProps> = ({ title, children }) => (
  <section className={ styles.section }>
    <div className={ styles.title }>{ title }</div>
    <div className={ styles.body }>{ children }</div>
  </section>
)

class Overview extends Component {
  static Section = OverviewSection

  render () {
    const { children } = this.props

    return (
      <div className={ styles.overview }>
        { children }
      </div>
    )
  }
}

export default Overview
